import { useEffect, useState } from "react";
import { ContractGroupInput, CUSTOM_FIELD_TYPE, CustomFieldModel } from "src/api/contractGroup/contractgroup-type";
import { BaseButton } from "src/components";
import Link from "src/components/PartnerLink";
import { PagePath } from "src/pages/product/details";
import { isUrl, ViewYmdFormat, formatLargeNumberString } from "src/utils/common-util";
import { useContractGroup } from "../../hooks/useContractGroup";
import moment from "moment";

type ViewCustomField = CustomFieldModel & {
  inputValue: string | null;
};

type Props = {
  groupCustomFields: ContractGroupInput[];
};

const ContractGroupCustomFieldSection = ({ groupCustomFields }: Props) => {
  const [customFields, setCustomFields] = useState<ViewCustomField[]>([]);
  const { getCtGroupCustomField } = useContractGroup();

  useEffect(() => {
    const fetchData = async () => {
      const customFields = await getCtGroupCustomField();
      const visibleCustomFields = customFields.filter((item) => item.isVisible); // 노출이 true인 커스텀 필드 목록

      const viewCustomFields = visibleCustomFields.map((item) => ({
        // 커스텀 필드에 입력값 추가 > inputValue, optionList
        ...item,
        inputValue: groupCustomFields.find((field) => field.fieldId === item.fieldId)?.inputValue || null,
        optionList: item.optionList?.filter((option) =>
          groupCustomFields.find((field) => field.fieldId === item.fieldId)?.optionList?.some((option2) => option2.optionId === option.optionId),
        ),
      }));

      setCustomFields(viewCustomFields);
    };

    fetchData();
  }, [groupCustomFields]);

  // 커스텀 필드 타입에 따라 입력값 표시
  const handleChange = (data: ViewCustomField, type: string) => {
    if (type === CUSTOM_FIELD_TYPE.NUMBER) {
      const formattedValue = formatLargeNumberString(data.inputValue);
      return formattedValue || "-";
    }
    if (type === CUSTOM_FIELD_TYPE.URL) {
      return isUrl(String(data.inputValue)) ? (
        <a className="text-underline text-blue3" href={String(data.inputValue)} target="_blank" rel="noopener noreferrer">
          {data.inputValue}
        </a>
      ) : (
        "-"
      );
    }

    if (type === CUSTOM_FIELD_TYPE.TEXT) {
      return data.inputValue || "-";
    }

    if (type === CUSTOM_FIELD_TYPE.CALENDAR) {
      return data.inputValue ? moment(data.inputValue).format(ViewYmdFormat.YYYY_MM_DD_WEEK) : "-";
    }

    if (type === CUSTOM_FIELD_TYPE.CHECKBOX) {
      return data.optionList?.map((item) => item.optionName).join(", ") || "-";
    }

    if (type === CUSTOM_FIELD_TYPE.RADIO) {
      return data.optionList?.map((item) => item.optionName).join(", ") || "-";
    }
    return data.inputValue || "-";
  };

  return (
    <article className="contents-container__wrap-article">
      <div className="contents-container__sub-title">
        <h2>커스텀 필드</h2>
      </div>

      {customFields.length > 0 ? (
        customFields.map((item) => (
          <section className="contents-container__grid" key={item.fieldId}>
            <div className="contents-container__grid-index">
              <p>{item.fieldName}</p>
            </div>
            <div className="contents-container__grid-contents">
              <div>
                <span> {handleChange(item, item.fieldType || "")}</span>
              </div>
            </div>
          </section>
        ))
      ) : (
        <div className="contents-container__grid-contents ">
          <div className="flex-row flex-center-start px20 py30" style={{ backgroundColor: "#f8f8fa", borderRadius: "10px" }}>
            <span>관리하는 계약의 운영 정보를 만들어 관리할 수 있어요.</span>
            <Link target="_blank" to={PagePath.contractGroup.customField}>
              <BaseButton className="color-white ml10" title="커스텀 필드 관리" />
            </Link>
          </div>
        </div>
      )}
    </article>
  );
};

export default ContractGroupCustomFieldSection;
